import { Route, Switch } from 'react-router';

import Form from './Pages/Form';
import Intro from './Pages/Intro';
import Success from './Pages/Success';
import Upload from './Pages/Upload';

const BASE_URL = '/siret-wall';

const SiretWall = () => (
  <Switch>
    <Route component={Intro} exact path={BASE_URL} />
    <Route component={Form} path={`${BASE_URL}/form`} />
    <Route component={Upload} path={`${BASE_URL}/upload`} />
    <Route component={Success} path={`${BASE_URL}/success`} />
  </Switch>
);

export default SiretWall;
